import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Tabs, Tab } from '@mui/material';
import { Breadcrumb } from 'components';
import { OnboardingClientPage } from 'modules/quote/Dashboard/pages/OnboardingClientPage';
import { BottleOrderPage } from 'modules/quote/Dashboard/pages/BottleOrderPage';
import { QuotesPage } from 'modules/quote/Dashboard/pages/QuotesPage';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  keepMounted?: boolean;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, keepMounted, ...other } = props;
  const shouldRender = value === index || keepMounted;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`dashboard-tabpanel-${index}`}
      aria-labelledby={`dashboard-tab-${index}`}
      {...other}
    >
      {shouldRender && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `dashboard-tab-${index}`,
    'aria-controls': `dashboard-tabpanel-${index}`,
  };
}

export function Dashboard() {
  const [tabValue, setTabValue] = useState(0);
  const [visitedTabs, setVisitedTabs] = useState<number[]>([0]);

  const nav: any = [
    { name: 'Home', path: '/home' },
    { name: 'Reports Overview', path: '/home/dashboard' }
  ];

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setVisitedTabs((prevVisitedTabs) => (
      prevVisitedTabs.includes(newValue) ? prevVisitedTabs : [...prevVisitedTabs, newValue]
    ));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Breadcrumb navList={nav} />
      </Box>

      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
        Dashboard Overview
      </Typography>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="dashboard tabs">
            <Tab label="Onboarding Clients" {...a11yProps(0)} />
            <Tab label="Bottle Order" {...a11yProps(1)} />
            <Tab label="Quotes" {...a11yProps(2)} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0} keepMounted={visitedTabs.includes(0)}>
          <OnboardingClientPage />
        </TabPanel>

        {/* Bottle Order and Quotes are not kept mounted so their filters reset on tab change */}
        <TabPanel value={tabValue} index={1}>
          <BottleOrderPage />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <QuotesPage />
        </TabPanel>
      </Box>
    </Box>
  );
}
